import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Card, CardContent} from "@material-ui/core";
import moment from "moment";
import EditableNotesCell from "../Parts/EditableNotesCell";

export default class StripeSubscriptions extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(Types.Stripe_Subscriptions_All._name, API.RequestType.READ_ALL);
		model.sort = 'subscription_created_date';
		model.order = 'desc';
		super(props, model);
		this.state.limit = 16;
	}

	saveNotes = async (rowId, notes) => {
		const notesModel = new API.BuildClass(Types.Stripe_Subscriptions_All._name, 'POST_NOTES');
		notesModel.object.stripe_id = rowId;
		notesModel.object.notes = notes;
		notesModel.grandparent = '9999-99999999';
		await notesModel.submit(null, 'POST_NOTES');
		this.setState(previousState => ({
			data: previousState.data.map(row => row.stripe_id === rowId ? {...row, notes} : row)
		}));
	};

	render() {
		const {data, pages, limit, loading} = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Stripe Subscriptions')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}>
										<i className="fa fa-refresh"/>
									</Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Notes",
									accessor: "notes",
									minWidth: 280,
									sortable: false,
									Cell: cellInfo => (
										<EditableNotesCell
											key={cellInfo.original.stripe_id}
											rowId={cellInfo.original.stripe_id}
											originalValue={cellInfo.original.notes}
											onSave={this.saveNotes}
										/>
									)
								},
								{
									Header: "Started",
									id: "subscription_created_date",
									width: 160,
									accessor: subscription => subscription.subscription_created_date ? moment(subscription.subscription_created_date).local().format("MM/DD/YYYY h:mm A") : '-'
								},
								{
									Header: "Account",
									id: "account_number",
									width: 90,
									sortable: false,
									accessor: subscription => subscription.account_number || '-'
								},
								{
									Header: "Company",
									id: "account_company",
									sortable: false,
									accessor: subscription => subscription.account_company || '-'
								},
								{
									Header: "Owner",
									id: "account_owner",
									sortable: false,
									accessor: subscription => subscription.account_owner || '-'
								},
								{
									Header: "Email",
									id: "account_email",
									sortable: false,
									accessor: subscription => subscription.account_email || '-'
								},
								{
									Header: "Location",
									id: "location_name",
									sortable: false,
									accessor: subscription => subscription.location_name || 'Account-level'
								},
								{
									Header: "Subscription",
									id: "subscription_display_name",
									sortable: false,
									accessor: subscription => subscription.module_display_name ||
										subscription.subscription_display_name ||
										subscription.upgrades_display_name ||
										subscription.plan_name || '-'
								},
								{
									Header: "Stripe Plan",
									id: "plan_name",
									accessor: subscription => subscription.plan_name || '-'
								},
								{
									Header: "Quantity",
									id: "quantity",
									width: 90,
									accessor: subscription => subscription.quantity !== null && subscription.quantity !== undefined && subscription.quantity !== '' ? subscription.quantity : '-'
								},
								{
									Header: "Monthly Value",
									id: "plan_amount",
									width: 125,
									sortable: false,
									accessor: subscription => subscription.plan_amount !== null && subscription.plan_amount !== undefined ? Intl.NumberFormat('en-US', {
										style: 'currency',
										currency: 'USD'
									}).format(((Number(subscription.plan_amount) || 0) * (Number(subscription.quantity) || 1)) / 100) : '-'
								},
								{
									Header: "Status",
									id: "status",
									width: 100,
									accessor: subscription => subscription.status || '-'
								},
								{
									Header: "Period Start",
									id: "current_period_start",
									width: 160,
									accessor: subscription => subscription.current_period_start ? moment(subscription.current_period_start).local().format("MM/DD/YYYY h:mm A") : '-'
								},
								{
									Header: "Period End",
									id: "current_period_end",
									width: 160,
									accessor: subscription => subscription.current_period_end ? moment(subscription.current_period_end).local().format("MM/DD/YYYY h:mm A") : '-'
								},
								{
									Header: "Ended",
									id: "subscription_ended_date",
									width: 160,
									accessor: subscription => subscription.subscription_ended_date ? moment(subscription.subscription_ended_date).local().format("MM/DD/YYYY h:mm A") : '-'
								},
								{
									Header: "Stripe Subscription ID",
									id: "stripe_id",
									width: 210,
									accessor: subscription => subscription.stripe_id || '-'
								}
							]}
							manual
							data={data}
							pages={pages}
							loading={loading}
							loadingText="Requesting Data"
							onFetchData={this.fetchData}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		);
	}
}
